import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ClientCouponService,
  ServicePromoCode,
  ServiceSubscription,
  SubscriptionService,
  ToastService
} from 'taxtank-core';
import { BaseComponent } from '@shared/component/base/base.component';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesEnum } from './messages.enum';
import { MaterialModule } from '@shared/material/material.module';
import { PreloaderModule } from '@shared/component';
import {
  PromoCodeComponent
} from '@client/shared/components/subscription/promo-code-form/promo-code/promo-code.component';
import { finalize } from 'rxjs/operators';

/**
 * Stripe promo code component
 */
@Component({
  selector: 'app-promo-code-form',
  templateUrl: './promo-code-form.component.html',
  styleUrls: ['./promo-code-form.component.scss'],
  imports: [
    MaterialModule,
    PreloaderModule,
    CommonModule,
    PromoCodeComponent
  ]
})
export class PromoCodeFormComponent extends BaseComponent implements OnInit {
  @Input() subscription: ServiceSubscription;
  /**
   * first payment per registered user could come with rewardful coupon
   */
  @Input() firstPayment: boolean;
  @Output() changed: EventEmitter<void> = new EventEmitter();
  errorMessage: string;

  /**
   * @TODO Artem: remove and use preloader via endpoints
   */
  isLoading: boolean;

  private subscriptionService = inject(SubscriptionService);
  private clientCouponService = inject(ClientCouponService);
  private toastService = inject(ToastService);

  ngOnInit(): void {
    // look for rewardful coupon for the first payment only
    if (this.firstPayment) {
      this.isLoading = true;
      this.clientCouponService.getFirst().pipe(
        finalize(() => {
          this.isLoading = false;
        })
      ).subscribe((promoCode) => {
        this.subscription.applyPromoCode(promoCode);
        this.changed.emit();
      });
    }
  }

  apply(promoCode: string): void {
    this.isLoading = true;
    // @TODO waiting for additional param isAnnual on backend
    this.subscriptionService.getCoupon(promoCode)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (promoCode: ServicePromoCode) => {
          if (this.subscription.applyPromoCode(promoCode)) {
            this.errorMessage = null;
            this.changed.emit();
          } else {
            this.errorMessage = MessagesEnum.PROMO_CODE_NOT_FOUND;
            this.toastService.error(MessagesEnum.PROMO_CODE_NOT_FOUND);
          }
        },
        // Handle error when user applied incorrect code (code does not exist)
        error: (error: HttpErrorResponse) => {
          if (error.status === 404) {
            this.errorMessage = MessagesEnum.PROMO_CODE_NOT_FOUND;
            this.toastService.error(MessagesEnum.PROMO_CODE_NOT_FOUND);
          }
        }
      });
  }

  remove(): void {
    this.subscription.promoCodes = [];
    this.changed.emit();
  }
}
